export function attachLoadingSpinner(type) {
  const elementForLoadingSpinner = document.createElement('div');
  elementForLoadingSpinner.classList.add('c-loading-spinner');
  (type) ? elementForLoadingSpinner.classList.add('c-loading-spinner--inline') : '';
  elementForLoadingSpinner.classList.add('circle');

  return elementForLoadingSpinner;
}
